module.exports = __webpack_public_path__ + "img/aedlogo.888ac768.png";